import { connect } from "react-redux";
import { withTranslation } from "@template/components/translation";
import {
  getStoreCode,
  getCountryCode
} from "@template/state/modules/regionalStore";
import { getNCCDiscountValue } from "./getNCCDiscountValue";
import NewsletterSignupForm from "./NewsletterSignupForm";

const mapStateToProps = state => {
  const storeCode = getStoreCode(state);
  const countryCode = getCountryCode(state);
  const { discount, showNCCMessaging } = getNCCDiscountValue(
    storeCode,
    countryCode
  );

  return discount
    ? { showNCCMessaging, discountValue: discount }
    : { showNCCMessaging };
};

export default connect(mapStateToProps)(withTranslation(NewsletterSignupForm));
